/**
 * Get the API base URL based on environment.
 *
 * For mobile testing, you need to:
 * 1. Find your computer's local IP address (e.g., 192.168.1.100)
 * 2. Set REACT_APP_API_URL in your .env file to http://YOUR_IP:8000
 * 3. Make sure your phone and computer are on the same WiFi network
 * 4. Ensure your backend CORS_ORIGINS includes your phone's origin
 */

/**
 * Get the API base URL, with fallback for mobile testing
 */
export function getApiUrl(): string {
  // Check if REACT_APP_API_URL is explicitly set (available at build time)
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // Check if we're running on a mobile device or different host
  const hostname = window.location.hostname;
  const protocol = window.location.protocol;

  // Handle production domain (mariahblue.com -> api.mariahblue.com)
  if (hostname === "mariahblue.com" || hostname === "www.mariahblue.com") {
    return "https://api.mariahblue.com";
  }

  // If not localhost, use the current hostname (for mobile testing)
  if (hostname !== "localhost" && hostname !== "127.0.0.1") {
    // Extract port from current URL or use default 8000
    const port = window.location.port || "8000";
    // Use the same protocol as the current page (http or https)
    return `${protocol}//${hostname}:${port === "3000" ? "8000" : port}`;
  }

  // Default to localhost for desktop development
  return "http://localhost:8000";
}
